import React from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "50%",
    height: "250px",
    width: "250px",
  },
}));

const ProfilePicture = ({ picturePath, className }) => {
  const classes = useStyles();
  const currentUser = useSelector((state) => state.userPreferences.username);
  const { username } = useParams();
  const imageDescription = username
    ? `${username}'s profile picture`
    : `${currentUser}'s profile picture`;

  return (
    <div className={className}>
      <img src={picturePath} alt={imageDescription} className={classes.root} />
    </div>
  );
};

export default ProfilePicture;
